import { ProjectService } from 'src/services/project.service'
import { TPatientFollowupDocument } from './use-patient-followup-documents.hook'

/**
 * A received document is stored either through a form (`patientFormId` set)
 * or as a standalone file, each served by its own endpoint.
 */
const getPatientFollowupDocumentFile = (
  document: Pick<TPatientFollowupDocument, 'variableId' | 'patientFormId'>,
  patientId: string | number,
  projectId: string | number,
) =>
  document.patientFormId === null
    ? ProjectService.getStandalonePatientVariableDocument(document.variableId, patientId, projectId)
    : ProjectService.getPatientFormDocument(document.variableId, document.patientFormId, patientId, projectId)

export { getPatientFollowupDocumentFile }
